const apiBase = `${process.env.REACT_APP_API_BASE}/api/v1`;

//User authentication
export const login_endpoint = `${apiBase}/login/`;
export const registration_login_endpoint = `${apiBase}/registration_login/`;
export const registration_endpoint = `${apiBase}/registration/`;
export const password_reset_endpoint = `${apiBase}/password_reset/`;
export const password_set_endpoint = `${apiBase}/password/reset/`;
export const password_change_endpoint = `${apiBase}/password_change/`;
export const privacy_settings_endpoint = `${apiBase}/privacy_settings/`;
export const mfa_endpoint = `${apiBase}/2fa/`;

//profile
export const profile_endpoint = `${apiBase}/profile/`;
export const user_reward_mark_claimed = `${apiBase}/user_reward/mark_claimed/`;
export const profile_image = `${apiBase}/profile_image/`;
export const endorsement_endpoint = `${apiBase}/endorsement/`;
export const user_reward_endpoint = `${apiBase}/user_reward/`;

export const team_endpoint = `${apiBase}/team/`;
export const organization_endpoint = `${apiBase}/organization/`;
export const certificates_endpoint = `${apiBase}/certificates/`;
export const workgroup_endpoint = `${apiBase}/workgroup/`;
export const competences = `${apiBase}/competence/`;
export const career_path = `${apiBase}/career_path/`;
export const career_path_job_position = `${apiBase}/career_path/job_positions/`;
export const user_learning_report_endpoint = `${apiBase}/user_learning_report/`;
export const learning_report_endpoint = `${apiBase}/learning_report/`;
export const learning_report_context_endpoint = `${apiBase}/learning_report_context/`;
export const platform_dashboard = `${apiBase}/platform/dashboard/`;
export const platform_instructor_details = `${apiBase}/platform/instructor_details/`;

//Organization licenses/licence control
export const license_endpoint = `${apiBase}/license/`;
export const platform_licenses_endpoint = `${apiBase}/platform/licenses/`;
export const platform_prepaids_endpoint = `${apiBase}/platform/prepaids/`;
export const platform_organizations_endpoint = `${apiBase}/platform/organizations/`;
export const platform_users_endpoint = `${apiBase}/platform/users/`;
export const invoice_endpoint = `${apiBase}/invoice/download/`;
export const platform_invoices_endpoint = `${apiBase}/platform/invoices/`;
export const organizationUnassingLicense = `${apiBase}/license/unassign/`;
export const license_assign_endpoint = `${apiBase}/license/assign/`;
export const downloadContract = `${apiBase}/org_contract/download/`;

//courses
export const courses = `${apiBase}/courses/`;
export const course_assign_endpoint = `${apiBase}/course_assign/`;
export const courseDetails = `${apiBase}/course_details/`;
export const courseMaterial = `${apiBase}/course_material/download/`;
export const course_likes_endpoint = `${apiBase}/course_likes/`;
export const course_share_endpoint = `${apiBase}/course_share/`;
export const courseEnroll = `${apiBase}/course_enroll/`;

//Individual development plan
export const idp_endpoint = `${apiBase}/idp/`;
export const idp_delete_endpoint = `${apiBase}/idp_delete/`;
export const idp_comment_endpoint = `${apiBase}/idp_comment/`;
export const learning_plan_endpoint = `${apiBase}/learning_plan/`;

export const search = `${apiBase}/search/`;

//Home page
export const user_homepage = `${apiBase}/user_homepage/`;
export const bonus_buy = `${apiBase}/bonus/buy/`;
export const course_suggestion = `${apiBase}/course_suggestion/`;
export const competition_entry = `${apiBase}/competition_entry/`;
export const lottery_tickets = `${apiBase}/lottery/tickets/`;

//chat
export const chatroom = `${apiBase}/chatroom/`;
export const chat = `${apiBase}/chat/`;
export const chat_search = `${apiBase}/chat_search/`;
export const chatbot_endpoint = `${apiBase}/chatbot/`;

//Notifications
export const notification_endpoint = `${apiBase}/notification/`;
export const notification_settings_endpoint = `${apiBase}/notification_settings/`;

//Registration Competences & Test
export const initial_test_endpoint = `${apiBase}/initial_test/`;
export const user_competence_endpoint = `${apiBase}/user_competence/`;
export const test_endpoint = `${apiBase}/test/`;
export const problem_answer_endpoint = `${apiBase}/problem_answer/`;
export const problem_feedback_endpoint = `${apiBase}/problem_feedback/`;

export const view_context_endpoint = `${apiBase}/view_context/`;
export const profession_endpoint = `${apiBase}/profession/`;
export const education_endpoint = `${apiBase}/education/`;
export const experience_endpoint = `${apiBase}/experience/`;
export const notes_endpoint = `${apiBase}/notes/`;
export const marketplace_endpoint = `${apiBase}/marketplace/`;
export const my_organization_endpoint = `${apiBase}/my_organization/`;
export const job_positions_endpoint = `${apiBase}/job_position/`;
export const job_position_competence_endpoint = `${apiBase}/job_position_competence/`;
export const competence_endpoint = `${apiBase}/competence/`;
export const competence_group_endpoint = `${apiBase}/competence_group/`;
export const competence_level_endpoint = `${apiBase}/competence_level/`;
export const courses_endpoint = `${apiBase}/courses/`;
export const courses_list_endpoint = `${apiBase}/course_list/`;
export const course_content_endpoint = `${apiBase}/course_content/`;
export const course_content_pdf_endpoint = `${apiBase}/course_content_pdf/`;
export const course_material_pdf_endpoint = `${apiBase}/course_material_pdf/`;
export const user_video_statistics_endpoint = `${apiBase}/user_video_statistics/`;
export const user_pdf_statistics_endpoint = `${apiBase}/user_pdf_statistics/`;
export const user_material_statistics_endpoint = `${apiBase}/user_material_statistics/`;
export const course_review_endpoint = `${apiBase}/course_review/`;
export const course_edit_endpoint = `${apiBase}/course_edit/`;
export const course_audit_endpoint = `${apiBase}/course_audit/`;
export const collection_endpoint = `${apiBase}/collection/`;
export const documents_endpoint = `${apiBase}/platform/documents/`;
export const document_audit_endpoint = `${apiBase}/platform/document_audit/`;
export const instructor_endpoint = `${apiBase}/instructor/`;
export const instructor_dashboard_endpoint = `${apiBase}/instructor_dashboard/`;
export const instructor_review_endpoint = `${apiBase}/instructor_review/`;
export const learning_event_endpoint = `${apiBase}/learning_event/`;
export const calendar_event_endpoint = `${apiBase}/calendar_event/`;
export const regulatory_intelligence_endpoint = `${apiBase}/regulatory_intelligence/`;
export const regulatory_intelligence_likes_endpoint = `${apiBase}/ri_likes/`;
export const regulatory_intelligence_share_endpoint = `${apiBase}/ri_share/`;
export const tracking_event_endpoint = `${apiBase}/tracking_event/`;
